import { render, staticRenderFns } from "./view-declaration-modal.vue?vue&type=template&id=16c350c3&scoped=true"
import script from "./view-declaration-modal.vue?vue&type=script&lang=js"
export * from "./view-declaration-modal.vue?vue&type=script&lang=js"
import style0 from "./view-declaration-modal.vue?vue&type=style&index=0&id=16c350c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c350c3",
  null
  
)

export default component.exports